'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function ProgressBar(props) {
    // calculate props for progress element
    // progress element width is < 100% because labels take up space on the edges
    var style = { width: (props.numSteps - 1) / props.numSteps * 100 + '%' };
    var value = props.numSubsteps * (props.numStepsCompleted - 1) + props.numSubstepsCompleted;
    var max = props.numSubsteps * (props.numSteps - 1);
    var progressProps = { value: value, max: max, style: style };

    var stepIndicators = Array.from(Array(props.numSteps)).map(function (_, i) {
        var className = 'progress-item';
        if (i === props.numStepsCompleted - 1 && props.numSubstepsCompleted === 0) {
            className += ' active';
        } else if (i < props.numStepsCompleted) {
            className += ' complete';
        }
        return _react2['default'].createElement(
            'li',
            { className: className, key: i },
            props.stepNames[i]
        );
    });

    return _react2['default'].createElement(
        'div',
        { className: 'ProgressBar' },
        _react2['default'].createElement('progress', progressProps),
        _react2['default'].createElement(
            'ol',
            null,
            stepIndicators
        )
    );
}

ProgressBar.propTypes = {
    numSteps: _propTypes2['default'].number,
    numStepsCompleted: _propTypes2['default'].number,
    numSubsteps: _propTypes2['default'].number,
    numSubstepsCompleted: _propTypes2['default'].number,
    stepNames: _propTypes2['default'].arrayOf(_propTypes2['default'].string)
};

ProgressBar.defaultProps = {
    numSteps: 0,
    numStepsCompleted: 0,
    numSubsteps: 1,
    numSubstepsCompleted: 0,
    stepNames: []
};

module.exports = ProgressBar;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/ProgressBar.js
// module id = 323
// module chunks = 0